import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../../core/layout/Breadcrumb';

const UnitItemHistoryBreadcrumbs = (props) => (
  <Breadcrumb
    fetching={props.fetching}
    crumbs={[
      {
        text: `Course - ${props.unitItem.unit.module.course.name}`,
        link: '/modules',
      },
      {
        text: `Module - ${props.unitItem.unit.module.name}`,
        link: `/modules/${props.unitItem.unit.module.id}/details`,
      },
      {
        text: `Unit - ${props.unitItem.unit.name}`,
        link: `/modules/${props.unitItem.unit.module.id}/units/${props.unitItem.unit.id}`,
      },
      {
        text: 'Unit items',
        link: `/modules/${props.unitItem.unit.module.id}/units/${props.unitItem.unit.id}/items`,
      },
      {
        text: 'History',
      },
    ]}
  />
);

UnitItemHistoryBreadcrumbs.propTypes = {
  fetching: PropTypes.bool,
  unitItem: PropTypes.shape({
    unit: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      module: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        course: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

UnitItemHistoryBreadcrumbs.defaultProps = {
  fetching: false,
};

export default UnitItemHistoryBreadcrumbs;
